import { styled } from 'styled-components'

export const VerticalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => `${props.theme.marginXXS}px`};
`
